import type { FC } from 'react';

import { useAppSelector } from 'features/app/hooks';
import {
  CallDetailsCalleeConnectedContainer,
  CallDetailsCalleeDisconnectedContainer,
  CallDetailsCalleeDisconnectedFast,
  CallDetailsCalleeReconnectContainer,
  CallDetailsChangeNumberContainer,
  CallDetailsNewCallContainer,
} from 'features/call/call-details/components';
import { CallDetailsStatus } from 'features/call/call-details/enums';
import { useCallDetailsParticipantHandler } from 'features/call/call-details/hooks';
import { callDetailsStatusSelector } from 'features/call/call-details/store';
import { useDeafAutoConnectForHearingToDeafCall } from 'features/call/call-hearing-to-deaf/hooks';
import {
  useCallDetailsStatusHandler,
  useRegularVrsCallDetailsUpdateFromParticipants,
} from 'features/call/vrs-call/hooks';
import { EmergencyCallbackInfo } from 'features/emergency/components';
import { isEmergencyCallbackTypeSelector } from 'features/emergency/store';
import { SignMailText } from 'features/signmail/components';
import {
  CallDetailsChangeNumberVco2Line,
  CallDetailsAddNumberVco2Line,
} from 'features/vco-2-line/components';

export const VrsCallDetails: FC = () => {
  const callDetailsStatus = useAppSelector(callDetailsStatusSelector);
  const isEmergencyCallbackType = useAppSelector(
    isEmergencyCallbackTypeSelector
  );

  useCallDetailsParticipantHandler();
  useCallDetailsStatusHandler();
  useDeafAutoConnectForHearingToDeafCall();
  useRegularVrsCallDetailsUpdateFromParticipants();
  return (
    <>
      {isEmergencyCallbackType && <EmergencyCallbackInfo />}
      {callDetailsStatus === CallDetailsStatus.CALLEE_DISCONNECTED && (
        <CallDetailsCalleeDisconnectedContainer />
      )}
      {callDetailsStatus === CallDetailsStatus.CALLEE_DISCONNECTED_FAST && (
        <CallDetailsCalleeDisconnectedFast />
      )}
      {callDetailsStatus === CallDetailsStatus.CALLEE_CONNECTED && (
        <CallDetailsCalleeConnectedContainer />
      )}
      {callDetailsStatus === CallDetailsStatus.CALLEE_RECONNECT && (
        <CallDetailsCalleeReconnectContainer />
      )}
      {callDetailsStatus === CallDetailsStatus.CHANGE_NUMBER && (
        <CallDetailsChangeNumberContainer />
      )}
      {callDetailsStatus === CallDetailsStatus.NEW_CALL && (
        <CallDetailsNewCallContainer />
      )}
      {callDetailsStatus === CallDetailsStatus.CHANGE_NUMBER_VCO_2_LINE && (
        <CallDetailsChangeNumberVco2Line />
      )}
      {callDetailsStatus === CallDetailsStatus.NEW_VCO_2_LINE && (
        <CallDetailsAddNumberVco2Line />
      )}
      <SignMailText />
    </>
  );
};
